import { render } from "./hot-office.vue?vue&type=template&id=12dad938&scoped=true"
import script from "./hot-office.vue?vue&type=script&lang=js"
export * from "./hot-office.vue?vue&type=script&lang=js"

import "./hot-office.vue?vue&type=style&index=0&id=12dad938&lang=scss&scoped=true"

import exportComponent from "/www/publicHouse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12dad938"]])

export default __exports__